import React, { useEffect, useState } from "react";


import styles from "../Style/List.module.css";

import { Stack } from "@fluentui/react/lib/Stack";

import stylesList from "./WorkSpaceItemList.module.css";

import { BatchChangeStatusModel, BatchDownloadModel, IBatchActionContent, IPath } from "../../model/ItemModel";
import { NewFolderConfig } from "./PanelItens/CreateFolderComp";

import { IconButton } from '@fluentui/react/lib/Button';
import { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { addIcon, batchActionIcon, refreshIcon } from '../../assets/icons';
import documentIcon from '../../assets/icons/documento.svg';
import downloadIcon from '../../assets/icons/download.svg';
import pasteIcon from '../../assets/icons/folder_alter.svg';
import draft from '../../assets/icons/iconDisable/draft';
import release from '../../assets/icons/iconDisable/release';
import userPermissions from '../../assets/icons/permissoes-de-usuarios.svg';
import permissions from '../../assets/icons/permissoes.svg';
import ChooseColumns from "../../components/ChooseColumns/ChooseColumns";
import MenuStiledRenderProps from "../../components/Menu/MenuStiledRender";
import { BatchDownloadPost, SetBatchDraft, SetBatchRelease } from "../../services/Item/ItemServicesCRUD";
import { DownloadWithoutLogin, GetOneItem } from "../../services/Item/ItemServicesGet";
import { PreValidationBatchAction } from "../../services/ValidationRuleService";
import { PathListingMap } from "./PathListingMap";
import { filesSelected } from "./WorkSpaceItemListFile";
import { Button, Divider, Tooltip, Typography } from "@mui/material";
import BtnBigWithIcon from "../../components/Button/BtnBigWithIcon/BtnBigWithIcon";
import { Add } from "@mui/icons-material";
import FolderIcon from '@mui/icons-material/Folder';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RefreshIcon from '@mui/icons-material/Refresh';
import MoveInBatch from "./MoveInBatch/MoveInBatch";
import { useProfile } from "../../context/ProfileProvider/useProfile";
import useExtractPlan from "../../hooks/useExtractPlan";
import { KeydrivePlan } from "../../model/UserModel";
import KeydriveTooltip from "../../components/KeydriveComponents/Tooltip/KeydriveTooltip";

interface WorkSpaceItemListFileHeaderProps {
    nameOrg: string;
    idWorkspace: string;
    idMongoNewFolder?: string;
    clickUpload: () => void;
    clickUploadFolder: () => void;
    refresh: () => void;
    setFolderConfig: (newFolder: NewFolderConfig) => void;
    typePermission?: number;
    isAdmin: boolean;
    path: IPath[];
    nameFolder: string;
    onClickLinkMap: (idFolder: string | undefined, nameFolder: string | undefined) => void;
    selectedCheckboxes: filesSelected[]
    setPopupError: (set: boolean, message: string) => void;
    setPopupOk: (set: boolean, message: string) => void;
    quantityFileSelected: () => number
    quantityAbleToReleaseSelected: () => number
    quantityAbleToDraftSelected: () => number
    setSelectedCheckbox: (set: filesSelected[]) => void;
    setCurrentBatchStatus: (set: "DRAFT" | "RELEASE") => void;
    batchRefresh: () => void;
    setBatchWaiter: (se: boolean) => void;
    setIsChecked: React.Dispatch<React.SetStateAction<boolean>>;
    setOpenBatchActionModal: (set: boolean) => void;
    setBatchActionContent: (set: IBatchActionContent) => void;
}

const WorkSpaceItemListFileHeader: React.ForwardRefExoticComponent<WorkSpaceItemListFileHeaderProps> =
    React.forwardRef(({
        nameOrg,
        idWorkspace,
        idMongoNewFolder,
        clickUpload,
        clickUploadFolder,
        refresh,
        setFolderConfig,
        typePermission,
        isAdmin,
        path,
        nameFolder,
        onClickLinkMap,
        selectedCheckboxes,
        setPopupError,
        setPopupOk,
        quantityFileSelected,
        quantityAbleToReleaseSelected,
        quantityAbleToDraftSelected,
        setSelectedCheckbox,
        setCurrentBatchStatus,
        batchRefresh,
        setBatchWaiter,
        setIsChecked,
        setOpenBatchActionModal,
        setBatchActionContent
    }, ref) => {
        const { t, i18n } = useTranslation();
        const navegate = useNavigate();
        const [isActionBatch, setIsActionBatch] = useState<boolean>(false);
        const [isAbleToRelease, setIsAbleToRelease] = useState<boolean>(false);
        const [isAbleToDraft, setIsAbleToDraft] = useState<boolean>(false);
        const [menuItems, setMenuItems] = useState<IContextualMenuItem[]>([]);
        const [menuItemsBach, setMenuItemsBach] = useState<IContextualMenuItem[]>([]);
        const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
        const [needHiddenMenu, setNeedHiddenMenu] = useState<boolean>(false);
        const [isFolderOwner, setIsFolderOwner] = useState<boolean>(false);
        const { id } = useProfile();
        const { keydrivePlan } = useExtractPlan();

        const preValidationExecute = () => {
            PreValidationBatchAction(
                selectedCheckboxes.filter(x => x.isFolder == false).flatMap(sc => sc.id!)
            )
                .then(data => {
                    setOpenBatchActionModal(true)
                    setBatchActionContent(data);
                })
                .catch(error => {
                    setOpenBatchActionModal(true)
                })
        }

        const refreshClick = (event: React.MouseEvent<HTMLElement>) => {
            if (refresh)
                refresh();
        };

        const upload = () => {
            if (clickUpload) clickUpload();

            return true;
        };

        const uploadFolder = () => {
            if (clickUploadFolder) clickUploadFolder();

            return true;
        };

        const nefolder = () => {
            const newFolder: NewFolderConfig = {
                idWork: idWorkspace,

                idFolder: idMongoNewFolder,
            };

            setFolderConfig(newFolder);

            return true;
        };


        const permission = () => {
            navegate("/" + nameOrg + "/wsallowed/" + idWorkspace + "/Permission");

            return true;
        };

        const permissionUser = () => {
            navegate("/" + nameOrg + "/wsallowed/" + idWorkspace + "/UserPermission");
            return true;
        }

        const moveInBatchClick = () => {
            setIsModalOpen(true)
        }


        const batchDownloadClick = () => {
            const batchDownload: BatchDownloadModel = {
                IdItens: selectedCheckboxes.map(item => item.id),
            };
            BatchDownloadPost(batchDownload)
                .then(res => {
                    if (res.id != undefined) {
                        window.open(DownloadWithoutLogin(res.id), "_blank")?.focus();
                    }
                })
                .catch(err => {
                    setPopupError(true, t("DownloadFileError.message"));
                })
        }

        const batchReleaseClick = () => {
            const batchRelease: BatchChangeStatusModel = {
                idChangeStatus: selectedCheckboxes
                    .filter(item => item.isRelease === false && item.validationRule === undefined)
                    .map(item => item.id),
            }
            var filesReleased: filesSelected[] = selectedCheckboxes.map(file => {
                return {
                    extension: file.extension,
                    id: file.id,
                    img: file.img,
                    isFolder: file.isFolder,
                    name: file.name,
                    isRelease: true,
                    validationRule: undefined
                }
            });
            SetBatchRelease(batchRelease)
                .then(res => {
                    setSelectedCheckbox(filesReleased);
                    batchRefresh();
                    setPopupOk(true, t("FilesWentToRelease.message"))
                    setCurrentBatchStatus("RELEASE");
                    setIsChecked(false);
                })
                .catch(err => {
                    setPopupError(true, t("ErrorWhenUpdatingToRelease.message"));
                })
                .finally(() => {
                    setBatchWaiter(false);
                })
        }

        const batchDraftClick = () => {
            const batchDraft: BatchChangeStatusModel = {
                idChangeStatus: selectedCheckboxes
                    .filter(item => item.isRelease === true && item.validationRule === undefined && !item.isFolder)
                    .map(item => item.id),
            }
            var filesDrafted: filesSelected[] = selectedCheckboxes.map(file => {
                return {
                    extension: file.extension,
                    id: file.id,
                    img: file.img,
                    isFolder: file.isFolder,
                    name: file.name,
                    isRelease: false,
                    validationRule: undefined
                }
            })
            SetBatchDraft(batchDraft)
                .then(res => {
                    setSelectedCheckbox(filesDrafted);
                    batchRefresh();
                    setCurrentBatchStatus("DRAFT");
                    setPopupOk(true, t("FilesWentToDraft.message"));
                    setIsChecked(false);
                })
                .catch(err => {
                    setPopupError(true, t("ErrorWhenUpdatingToDraft.message"));
                })
        }

        useEffect(() => {
            if (needHiddenMenu) {
                setNeedHiddenMenu(false);
            }
        }, [needHiddenMenu]);

        useEffect(() => {
            if (selectedCheckboxes.length > 1) {
                if (quantityFileSelected() >= 2) {
                    setIsActionBatch(true)

                    if (quantityAbleToReleaseSelected() >= 2) {
                        setIsAbleToRelease(true)
                    } else {
                        setIsAbleToRelease(false)
                    }

                    if (quantityAbleToDraftSelected() >= 2) {
                        setIsAbleToDraft(true)
                    } else {
                        setIsAbleToDraft(false)
                    }
                } else {
                    setIsActionBatch(false);
                }
            } else {
                setIsActionBatch(false);
            }
        }, [selectedCheckboxes, isActionBatch])

        useEffect(() => {

            let items: IContextualMenuItem[] = [
                {
                    key: 'draft',
                    text: t('DocumentActionsMenu.draft'),
                    onClick: () => { batchDraftClick() },
                    disabled: !isAbleToDraft,
                    onRender: (item) =>
                        <MenuStiledRenderProps
                            item={item}
                            widthStandar={true}
                            disabled={!isAbleToDraft}
                            icon={InsertDriveFileIcon}
                            onClick={() => batchDraftClick()}
                        />
                },
                {
                    key: 'download',
                    text: t('DocumentActionsMenu.download'),
                    onClick: () => { batchDownloadClick() },
                    onRender: (item) =>
                        <MenuStiledRenderProps
                            item={item}
                            widthStandar={true}
                            disabled={false}
                            src={downloadIcon}
                            onClick={() => batchDownloadClick()}
                        />
                },
                {
                    key: 'release',
                    text: t('DocumentActionsMenu.release'),
                    onClick: () => { batchReleaseClick() },
                    disabled: !isAbleToRelease,
                    onRender: (item) =>
                        <MenuStiledRenderProps
                            item={item}
                            widthStandar={true}
                            disabled={!isAbleToRelease}
                            icon={CheckCircleIcon}
                            onClick={() => batchReleaseClick()}
                        />
                },
                {
                    key: 'Mover para',
                    text: t('DocumentActionsMenu.moveTo'),
                    onClick: () => { moveInBatchClick() },
                    onRender: (item) =>
                        <MenuStiledRenderProps
                            item={item}
                            widthStandar={true}
                            disabled={false}
                            icon={draft}
                            onClick={() => moveInBatchClick()}
                        />
                },
                {
                    key: 'batchForward',
                    text: t('DocumentActionsMenu.preValidationOfAction'),
                    onClick: () => { preValidationExecute() },
                    disabled: !isAbleToDraft,
                    onRender: (item) =>
                        <MenuStiledRenderProps
                            item={item}
                            widthStandar={true}
                            disabled={false}
                            icon={release}
                            onClick={() => {
                                preValidationExecute()
                                setNeedHiddenMenu(true);
                            }}
                        />
                },
            ];

            setMenuItemsBach(items);
        }, [isAbleToRelease, isAbleToDraft, selectedCheckboxes]);

        useEffect(() => {
            if (idMongoNewFolder !== undefined) {
                GetOneItem(idMongoNewFolder)
                    .then(data => {
                        setIsFolderOwner(data.ownerId == id);
                    })
                    .catch()
            }
        }, [idMongoNewFolder])

        useEffect(() => {
            let items: IContextualMenuItem[] = [
                {
                    key: 'upload',
                    text: t("Upload.file"),
                    onClick: () => { upload() },
                    onRender: (item) =>
                        <MenuStiledRenderProps
                            item={item}
                            widthStandar={true}
                            disabled={false}
                            src={documentIcon}
                            onClick={() => upload()}
                        />
                },
                {
                    key: 'Uploadfolder',
                    text: t("Upload.folder"),
                    onClick: () => { uploadFolder() },
                    disabled: !isAbleToRelease,
                    onRender: (item) =>
                        <MenuStiledRenderProps
                            item={item}
                            widthStandar={true}
                            disabled={false}
                            src={pasteIcon}
                            onClick={() => uploadFolder()}
                        />
                },
                {
                    key: 'newFolder',
                    text: t("Upload.newFolder"),
                    onClick: () => { nefolder() },
                    disabled: !isAbleToRelease,
                    onRender: (item) =>
                        <MenuStiledRenderProps
                            item={item}
                            widthStandar={true}
                            disabled={false}
                            src={pasteIcon}
                            onClick={() => nefolder()}
                        />
                }
            ];

            setMenuItems(items);
        }, [isAdmin, isFolderOwner]);

        const closeModal = () => {
            setIsModalOpen(false)
        };


        return (
            <>
                <Box className={stylesList.header}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <Box sx={{
                            background: "#E8EFF3",
                            height: '36px',
                            width: '36px',
                            borderRadius: '2px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}>
                            <FolderIcon sx={{
                                color: '#22638D',
                            }} />
                        </Box>

                        <Typography sx={{ font: "normal normal 600 20px/27px Segoe UI", color: "#2D2D2D" }}>{t("WorkspaceList.Documents")}</Typography>
                    </Box>
                    <IconButton
                        className={stylesList.addButton}
                        disabled={typePermission !== 3}
                        menuProps={{
                            items: menuItems,
                            styles: {
                                root: {
                                    border: '1px solid #22638D',
                                    borderRadius: '4px',
                                    zIndex: -1
                                },
                                subComponentStyles: {
                                    callout: {
                                        root: {
                                            marginTop: '4px',
                                            marginRight: '68px'
                                        },
                                    },
                                },
                            },
                            hidden: needHiddenMenu,
                        }}
                        styles={{
                            menuIcon: {
                                display: 'none'
                            },
                        }}
                    >
                        <Add sx={{ color: "#fff", marginRight: '8px' }} />
                        {t("WorkspaceList.New")}
                    </IconButton>
                </Box>

                <Box>
                    <Typography sx={{
                        margin: "11px 0 0",
                        font: "normal normal normal 14px/21px Segoe UI"
                    }}>
                        {t("WorkspaceList.HeaderText")}
                    </Typography>
                </Box>

                <Divider sx={{ margin: "20px 0px" }} />

                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
                    <IconButton
                        disabled={!isActionBatch && selectedCheckboxes.length == 0}
                        style={{
                            height: '38px',
                            border: '1px solid #22638D',
                            borderRadius: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#22638D',
                            opacity: !isActionBatch && selectedCheckboxes.length == 0 ? '0.4' : '1'
                        }}
                        menuProps={{
                            items: menuItemsBach,
                            styles: {
                                root: {
                                    width: '208px',
                                    border: '1px solid #22638D',
                                    borderRadius: '4px',
                                },
                                subComponentStyles: {
                                    callout: {
                                        root: {
                                            marginTop: '4px'
                                        },
                                    },
                                },
                            },
                        }}
                        styles={{
                            menuIcon: {
                                display: 'none'
                            }
                        }}
                    >
                        <Add sx={{ color: "#22638D ", marginRight: '8px' }} />
                        {t("WorkspaceList.DocumentActions")}
                        <ArrowDropDownIcon />
                    </IconButton>
                    <Box sx={{ display: 'flex', gap: '10px' }}>

                        <IconButton
                            style={{
                                width: '38px',
                                height: '38px',
                                border: '1px solid #22638D',
                                borderRadius: '4px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                            styles={{
                                menuIcon: {
                                    display: 'none'
                                }
                            }}
                            onClick={refreshClick}
                        >
                            <Tooltip title={t("Atualizar.message")}>
                                <RefreshIcon sx={{ color: '#22638D' }} />
                            </Tooltip>
                        </IconButton>

                        <ChooseColumns />
                    </Box>
                </Box>
                <MoveInBatch
                        hideModal={closeModal}
                        isModalOpen={isModalOpen}
                        listItem={selectedCheckboxes}
                        batchRefresh={batchRefresh}
                        idWorkspace={idWorkspace}
                        isMovingOneItem={false}
                    />
        </>
        );
    });



export default WorkSpaceItemListFileHeader;
